import { render, staticRenderFns } from "./PosPaymentsPage.vue?vue&type=template&id=f7c98062&scoped=true"
import script from "./PosPaymentsPage.vue?vue&type=script&lang=js"
export * from "./PosPaymentsPage.vue?vue&type=script&lang=js"
import style0 from "./PosPaymentsPage.vue?vue&type=style&index=0&id=f7c98062&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7c98062",
  null
  
)

export default component.exports